/* eslint-disable */
<template>
    <v-container grid-list-xl fluid style="direction: rtl;padding-right: 15px">

    <v-layout row wrap >

        <v-flex lg6 sm12 xs12>
            <v-widget title="لإنخراط في منظمة مهنية" content-bg="white">
                <div slot="widget-content" id="q55" style="height:400px; " ref="q55">
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="هل لك دراية بنقابات الشغل ؟" content-bg="white">
                <div slot="widget-content" id="q56" style="height:400px; " ref="q56">
                </div>
            </v-widget>
        </v-flex>

    </v-layout>
    </v-container>
</template>

<script>
    import EChart from '@/components/chart/echart';
    import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
    import PostListCard from '@/components/widgets/card/PostListCard';
    import ProfileCard from '@/components/widgets/card/ProfileCard';
    import PostSingleCard from '@/components/widgets/card/PostSingleCard';
    import WeatherCard from '@/components/widgets/card/WeatherCard';
    import PlainTable from '@/components/widgets/list/PlainTable';
    import PlainTableOrder from '@/components/widgets/list/PlainTableOrder';
    import VWidget from '@/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import VCircle from '@/components/circle/VCircle';
    import BoxChart from '@/components/widgets/chart/BoxChart';
    import ChatWindow from '@/components/chat/ChatWindow';
    import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
    import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
    var echarts = require('../../node_modules/echarts');

    /* eslint-disable */
    export default {
        name: "q1-compenent",
        components: {
            VWidget,
            MiniStatistic,
            ChatWindow,
            VCircle,
            WeatherCard,
            PostSingleCard,
            PostListCard,
            ProfileCard,
            EChart,
            BoxChart,
            CircleStatistic,
            LinearStatistic,
            PlainTable,
            PlainTableOrder
        },
        data() {
            return {
                color: Material,

                q44:'0',
                q45:'0',
                q46:{
                    a:'0',
                    b:'0',
                    c:'0',
                    d:'0',
                },
            }
        },
        computed: {
            activity() {
                return API.getActivity();
            },
            posts() {
                return API.getPost(3);
            },
            siteTrafficData() {
                return API.getMonthVisit;
            },
        },
        created(){



        },
        mounted(){
            this.  fetchData()

        },
        watch: {
            $route: function(newVal, oldVal) {
                this.fetchData()
            }
        },
        methods: {

            fetchData() {
                var labelOption1 = {

                    normal: {
                        fontSize: 16,
                        fontWeight:"bold"
                    }
                };
                const ECharts = window.echarts || undefined;
                if (ECharts === undefined) {
                    console.error('ECharts is not defined');
                }


                var myChart30 = ECharts.init(this.$refs.q55, 'material');
                var myChart31 = ECharts.init(this.$refs.q56, 'material');
                myChart30.showLoading();
                myChart31.showLoading();


                var formData = new FormData();
                if((this.$route.params.state)==='الكل'){
                    formData.append('pays','');
                }
                else {
                    formData.append('pays',this.$route.params.state);}
                this.$http.post('https://acg-generations.com/acg_laravel/public/question55',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                    var data = response.bodyText
                    var obj = JSON.parse(data);

                    this.q55=obj.q55;
                    this.q56=obj.q56;

                    myChart30.hideLoading();
                    myChart31.hideLoading();


                    var labelOption2 = {
                        normal: {
                            show: true,
                            position:"inside",
                            rotate:0,
                            distance: 0,
                            fontSize: 16,
                            fontWeight:"bold"
                        }
                    };

                    var labelOption = {
                        normal: {
                            show: true,
                            position:"insideBottom",
                            align: "left",
                            verticalAlign: "middle",
                            rotate: 68,
                            formatter: '{c} : {a}',
                            fontSize: 16,
                            color: "black",
                            rich: {
                                name: {
                                    border:0
                                }
                            }
                        }
                    };


                    /***********************************/
                    var arrayq55=[
                        {value:this.q55.a,     label: labelOption1, name:'جمعية'},
                        {value:this.q55.c,     label: labelOption1, name:'منظمات أخرى'},
                        {value:this.q55.b,     label: labelOption1, name:'مجمع'},
                        {value:this.q55.d,     label: labelOption1, name:'نقابة'},

                    ]
                    var count =this.q55.count
                    myChart30.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params)
                            {var id = params.dataIndex;
                                return Math.round(arrayq55[id].value * 0.01 *count);}
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['جمعية','مجمع','منظمات أخرى','نقابة'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            label: {normal: {formatter:'{d}% ', position: 'inner'}},
                            data:arrayq55

                        }]
                    });
                    /***********************************/
                    var arrayq56= [
                        {value:this.q56.a,     label: labelOption1, name:'لا'},
                        {value:this.q56.b,     label: labelOption1, name:'نعم'},
                    ]
                    var count =this.q56.count

                    myChart31.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params)
                            {var id = params.dataIndex;
                                return Math.round(arrayq56[id].value * 0.01 *count);}
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['لا','نعم'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius:'70%',

                            label: {normal: {formatter:'{d}% ', position: 'inner'}},
                            data:arrayq56

                        }]
                    });

                    /*********************************/
                }, response => {
                    // error callback
                });
            },
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/table6.vue